import { Flex, Popover, Skeleton, Typography } from 'antd';
import Title from 'antd/es/typography/Title';
import { ExclamationCircleOutlined } from '@ant-design/icons';

import WidgetCard, { WidgetTitle } from '../WidgetCard';
import { formatNumberWithComma, renderInfoValue } from 'utils/helpers';

import type { HotcashWidgetProps } from './HotCashWidget';

export const LateCashWidgetSkeleton = () => {
  return (
    <WidgetCard className="activity-widget activity-widget--late">
      <Skeleton active paragraph={{ rows: 1 }} />
    </WidgetCard>
  );
};

const LateCashWidget = ({
  isLoading,
  currency,
  amount,
}: HotcashWidgetProps) => {
  if (isLoading) return <LateCashWidgetSkeleton />;

  const renderPopoverContent = () => {
    return (
      <Flex style={{ maxWidth: '400px' }}>
        <Typography.Text>
          You should contact and remind the agronomist to deposit the cash at
          the bank as soon as possible.
        </Typography.Text>
      </Flex>
    );
  };

  return (
    <WidgetCard className="activity-widget activity-widget--late">
      <WidgetTitle type="normal">Late Cash</WidgetTitle>
      <Flex gap={10}>
        <Title
          ellipsis={{ tooltip: true }}
          level={3}
          className="m-0"
          style={{ maxWidth: '90%' }}
        >
          {renderInfoValue(
            `${formatNumberWithComma(amount)} ${amount <= 0 ? '' : currency}`,
          )}
        </Title>

        {amount > 0 && (
          <Popover
            trigger={'hover'}
            placement="topLeft"
            content={renderPopoverContent}
            arrow={false}
          >
            <ExclamationCircleOutlined
              style={{ color: '#ff4d4f', fontSize: '17.5px', margin: 0 }}
            />
          </Popover>
        )}
      </Flex>
    </WidgetCard>
  );
};

export default LateCashWidget;
